import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import tools from '@/tools';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();


// 测试代码


// 测试代码
onMounted(async () => {

    const params = tools.data.getUrlParams()

    console.log(params)

  

})

const pageOptions = ref({
  loading: false
})

const handleLogin = async () => {

  const params = tools.data.getUrlParams()
  if (params.code) {
    pageOptions.value.loading = true


    // const data = {
    //   "corp_id": params.state.replace('#/login', '').split('|')[0],
    //   "agent_id": params.state.replace('#/login', '').split('|')[1],
    //   "code": params.code
    // }

    // tools.request('/auth/custom/wecom/ticket', data, { method: 'post', module: 'https://function.meatou.com' }).then((ticket_result: any) => {
    //   if (ticket_result) {
    //     tools.cloud.auth.customAuthProvider().signIn(ticket_result.ticket).then(() => {

    //       tools.session.set('corp_id', data.corp_id)
    //       tools.session.set('agent_id', data.agent_id)

    //       UserModule.GetUserInfo({ corp_id: data.corp_id, agent_id: data.agent_id, userid: ticket_result.userid })
    //         .finally(() => {; getAgent() })
    //     })
    //   }
    // }).catch(err => { console.log(err); pageOptions.value.loading = false })
  }

}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, " 登录页 "))
}
}

})